// tslint:disable
export enum ContactInformationPurposeType {
    /**
     * @description UNKNOWN
     */
    UNKN = 0,
    /**
     * @description MAIN
     */
    MAIN = 1,
    /**
     * @description MARKETING
     */
    MKTG = 2,
    /**
     * @description SALES
     */
    SALES = 3,
    /**
     * @description CUSTOMER SERVICE
     */
    CUSTSER = 4,
    /**
     * @description HOME
     */
    HOME = 5,
    /**
     * @description WORK
     */
    WORK = 6,
    /**
     * @description SEASONAL
     */
    SEAS = 7,
    /**
     * @description OTHER
     */
    OTHR = 8,
}
